import { useEffect, useRef, useState } from 'react';

import { ListItemText, Tooltip } from '@mui/material';

interface TruncateTextProps {
  text: string;
  maxWidth?: number;
  id?: string;
}

export const TruncatedTextWithOptionalTooltip: React.FC<TruncateTextProps> = ({ text, maxWidth = 330, id }) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = spanRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const span = (
    <span
      ref={spanRef}
      style={{
        display: 'inline-block',
        maxWidth,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'bottom',
      }}
    >
      {text}
    </span>
  );

  return <ListItemText id={id} primary={isTruncated ? <Tooltip title={text}>{span}</Tooltip> : span} />;
};
